
import StarIcon from '@material-ui/icons/Star';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MenuProfile from '../Menu/MenuProfile';
import { IconButton, Typography } from "@material-ui/core";
import useStyles from "../../assets/styles/styles";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Header from "../GenericHeader/Header";
import { useResizeScreen } from "../../hooks/useResizeScreen";
import NotFound from '../HomeLogged/NotFound';
import CardCommunication from "../Menu/CardCommunication";
import { getAllCommunications } from '../../redux/actions/communicatedAction';


//
const AllCommunication = () => {
    const dispatch = useDispatch();
    const screenSize = useResizeScreen();
    const [ firstLoad, setFirstLoad ] = useState(true);
    const classes = useStyles();
    const comunicacionReducer =useSelector((state) => state.communicatedReducer.communication);
    const [communications, setCommunications] = useState(comunicacionReducer?.communication);



    useEffect(() => {
        if(firstLoad) {
            dispatch(getAllCommunications({email: window.localStorage.getItem('email')}));
            setCommunications(comunicacionReducer?.communication);
            setFirstLoad(false);
        } else {
            clickFilter("");
        }
    }, [comunicacionReducer]);


    const size = () => {
        if (screenSize.screen.sWidth < 800) {
            return (classes.card50);
        } else {
            return (classes.card100);
        }
    };

    const clickFilter = (selected) => {
        switch (selected) {
            case "LEIDOS":
                const readed = comunicacionReducer?.communication?.filter((x) => x.viewed);
                setCommunications(readed);
                break;
            case "NO LEIDOS":
                const notReaded = comunicacionReducer?.communication?.filter((x) => !x.viewed);
                setCommunications(notReaded);
                break;
            case "DESTACADOS":
                const favorite = comunicacionReducer?.communication?.filter((x) => x.favourite);
                setCommunications(favorite);
                break;
            case "TODOS":
                setCommunications(comunicacionReducer?.communication);
                break;
            default:
                setCommunications(comunicacionReducer?.communication);
                break;
        }
    };

    return (<>
        <MenuProfile />
        <Header title="Notificaciones" colorTitle="#0075C9" heightTitle="140px" />
        <div style={{ alignItems: "center", display: "flex", justifyContent: "center" }} className={classes.marginTop}>
            <IconButton onClick={() => { clickFilter("LEIDOS"); }} >
                <NotificationsIcon className={classes.iconReader} style={{ marginRight: '5px' }} />
                <Typography className={`${classes.txtDescription}`}>
                    LEIDOS
                </Typography>
            </IconButton>

            <IconButton onClick={() => { clickFilter("NO LEIDOS"); }} >
                <NotificationsIcon className={classes.notificationIcon} style={{ marginRight: '5px' }} />
                <Typography className={`${classes.txtDescription}`}>
                    NO LEIDOS
                </Typography>
            </IconButton>

            <IconButton onClick={() => { clickFilter("DESTACADOS"); }} >
                <StarIcon className={classes.iconDestacate} style={{ marginRight: '5px' }} />
                <Typography className={`${classes.txtDescription}`}>
                    DESTACADOS
                </Typography>
            </IconButton>

            <IconButton onClick={() => { clickFilter("TODOS"); }} >
                <NotificationsIcon className={classes.AllNotIcon} />
                <Typography className={`${classes.txtDescription}`}>
                    TODOS
                </Typography>
            </IconButton>

        </div>

        {
            communications?.length > 0
                ?
                <div className={classes.AllNotifications}>
                    {communications?.map((item, index) => {
                        return (
                            <div key={index} className={size()}>
                                <CardCommunication communication={item} position={null} />
                            </div>
                        );
                    })}
                </div>
                :
                <NotFound customMsg={
                    <div className={classes.contentNotFound}>
                        <span style={{ marginTop: "40px" }}>No hay comunicaciones</span>
                    </div>}
                    wsItem={communications}
                    fullItem={communications?.length}
                />
        }
    </>);
};

export default AllCommunication;